export default ['JsonRPCService', function (JsonRPCService) {
    return {
        getAccountContactSummary: function getAccountContactSummary() {
            return JsonRPCService.send('pc', 'profileinfo/user', 'getAccountContactSummary', []);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/services/UserAccountService.js
// module id = 862
// module chunks = 0